<template>
    <div class="component">

        <div class="wrap" style="background-color: #ffffff; height: 50px;">
            <div class="container">
                <div class="row justify-content-between" style="padding-top: 15px;">
                    <div class="col">
                         <p class="mb-0 phone"><span class="fa fa-phone"></span> <a class="number" href="tel:+8801771-997014">01771-997014</a></p>
                    </div>
                    <div class="col d-flex justify-content-end">
                        <div class="social-media">
                            <p class="mb-0 d-flex">
                                <a href="https://www.facebook.com/ibrand.bd.shop"><i class="fa-brands fa-square-facebook" style="cursor: pointer;"></i></a>
                                <a href="https://www.instagram.com/ibrand.bd.shop"><i class="fa-brands fa-instagram" style="cursor: pointer;"></i></a>
                                <a href="https://www.youtube.com/@ibrandbd"><i class="fa-brands fa-youtube" style="cursor: pointer;"></i></a>
                                <a href="https://maps.app.goo.gl/LrhcjifGc9d6KXPCA"><i class="fa-solid fa-location-dot" style="cursor: pointer;"></i></a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        

        <nav class="navbar border-bottom border-body navbar navbar-expand-lg bg-body-tertiary" style="background-color: #060606 !important; margin-bottom: 10px;">
                 <div class="container-fluid">
                    <router-link active-class="active" exact class="navbar-brand" to="/">
                        <img src="/img/logo.png" alt="" style="width: 150px;">
                    </router-link>
                     <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" style="background-color: #ffffff;">
                     <span class="navbar-toggler-icon"></span>
                     </button>
                     <div class="collapse navbar-collapse" id="navbarSupportedContent">
                     <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                         <li class="nav-item">
                    <router-link active-class="active" exact class="nav-link" to="/">
                        Home
                    </router-link>
                         </li>
                         <li class="nav-item">
                    <router-link active-class="active" exact class="nav-link" to="/about">
                        About
                    </router-link>
                         </li>
                         <li class="nav-item dropdown">
                         <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false" >
                             Products
                         </a>
                         <ul class="dropdown-menu">
                            <router-link active-class="active" exact style="cursor: pointer;" tag="li" class="nav-link dropdown-item" to="/panjabi-collection">Panjabi</router-link>
                            <router-link active-class="active" exact style="cursor: pointer;" tag="li" class="nav-link dropdown-item" to="/shirt-collection">Sirt</router-link>
                            <router-link active-class="active" exact style="cursor: pointer;" tag="li" class="nav-link dropdown-item" to="/pant-collection">Pant</router-link>
                         </ul>
                         </li>
                         <li class="nav-item">
                            <router-link active-class="active" exact style="cursor: pointer;" tag="li" class="nav-link dropdown-item" to="/contract">Contract</router-link>
                         </li>
                     </ul>
                     <form class="d-flex" role="search">
                         <input class="form-control me-2" type="search" placeholder="Search" aria-label="Search">
                         <button class="btn btn-outline-light" type="submit">Search</button>
                     </form> </div>
                 </div>
         </nav>
    </div>
</template>

<script>
    export default {
        name: 'NavCompo'
    }
</script>

<style>
    .nav-link{
        color: #999;
    }
    .navbar-nav .nav-link.active{
        color: #fff;
    }
    .navbar-nav .nav-link:hover{
        color: #fff;
    }
    span{
        color: #060606;
        font-size: 20px;
    }
    .number{
        text-decoration: none;
        color: #060606;
        margin-top: -50px;
    }
    .number:hover{
        color: #474747;
        transition: all 0.2s ease-in-out;
    }
    .fa-brands{
        color: #060606;
        margin-right: 20px;
        font-size: 22px;
    }
    .fa-solid{
        color: #060606;
        margin-right: 20px;
        font-size: 22px;
    }
    .fa-brands a i{

    }
    .fa-brands:hover{
        color: #474747;
        transition: all 0.2s ease-in-out;
    }
    .fa-solid:hover{
        color: #474747;
        transition: all 0.2s ease-in-out;
    }

</style>